module.exports = __webpack_public_path__ + "static/media/logo.c3b80678.png";